import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import './AboutUs.css';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import JoditEditor from 'jodit-react'; 
import Swal from 'sweetalert2'; 

const AboutUs = () => {
  const editorRef = useRef(null);
  const [aboutUsContent, setAboutUsContent] = useState(''); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/admin/about-us`)
      .then((response) => {
          console.log("pvesjadf",response);
        if (response.data.aboutUsData && response.data.aboutUsData.content) {
          setAboutUsContent(response.data.aboutUsData.content); 
        } else {
          setAboutUsContent('');
        }
        setLoading(false);
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || 'Failed to load About Us content.';
        setError(errorMessage);
        //Swal.fire('Error', errorMessage, 'error');
        setLoading(false);
      });
  }, []);

  const handleSave = async () => {
    if (!aboutUsContent.trim()) {
      Swal.fire('Error', 'About Us content cannot be empty', 'error'); 
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/about-us`,
        { content: aboutUsContent }
      );

      if (response.status === 200 || response.status === 201) {
      Swal.fire('Success', response.data.message || 'About Us content saved successfully!', 'success')
      .then(() => {
      window.location.reload();
      });
      } else {
        Swal.fire('Error', 'Something went wrong while saving the About Us content.', 'error');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to save About Us content.';
      Swal.fire('Error', errorMessage, 'error'); 
    }
  };

  const editorConfig = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing...',
  }), []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <DashboardLayout>
      <section className="MainSection">
        <Headings headspan="About" hedtext=" Us" />

        <div className="TermEditrDiv">
          <form>
            <JoditEditor
              ref={editorRef}
              value={aboutUsContent} 
              config={editorConfig}
              tabIndex={1}
              className="TermsFormsSec"
              onChange={(newContent) => setAboutUsContent(newContent)} 
            />
            <div className="SubMit">
              <button type="button" onClick={handleSave}>Save</button>
            </div>
          </form>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default AboutUs;
